import app from '../containers/app/AppReducer';
import widgetReducer from '../containers/widget/WidgetReducer';
import user from '../containers/login/LoginReducer';
import {reducer as form} from 'redux-form'
import {i18nReducer as i18n} from 'react-redux-i18n';

export default {
    widgetReducer,
    app,
    form,
    user,
    i18n
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js